module.exports = {
      id: "forward-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#forward",
      toString: function () {
        return this.url;
      }
    }